export const FETCH_PARTNERS_LIST = "FETCH_PARTNERS_LIST";
export const FETCH_PARTNERS_LIST_SUCCESS = "FETCH_PARTNERS_LIST_SUCCESS";
export const FETCH_PARTNERS_LIST_FAILED = "FETCH_PARTNERS_LIST_FAILED";

export const FETCH_PARTNERS_DETAILS = "FETCH_PARTNERS_DETAILS";
export const FETCH_PARTNERS_DETAILS_SUCCESS = "FETCH_PARTNERS_DETAILS_SUCCESS";
export const FETCH_PARTNERS_DETAILS_FAILED = "FETCH_PARTNERS_DETAILS_FAILED";

export const FETCH_STATE = "FETCH_STATE";
export const FETCH_STATE_SUCCESS = "FETCH_STATE_SUCCESS";
export const FETCH_STATE_FAILED = "FETCH_STATE_FAILED";

export const FETCH_CITY = "FETCH_CITY";
export const FETCH_CITY_SUCCESS = "FETCH_CITY_SUCCESS";
export const FETCH_CITY_FAILED = "FETCH_CITY_FAILED";

export const FETCH_PARTNERS_DETAILS_POST = "FETCH_PARTNERS_DETAILS_POST";
export const FETCH_PARTNERS_DETAILS_POST_SUCCESS =
  "FETCH_PARTNERS_DETAILS_POST_SUCCESS";
export const FETCH_PARTNERS_DETAILS_POST_FAILED =
  "FETCH_PARTNERS_DETAILS_POST_FAILED";

export const PIE_CHART_STATISTICS = "PIE_CHART_STATISTICS";
export const PIE_CHART_STATISTICS_SUCCESS = "PIE_CHART_STATISTICS_SUCCESS";
export const PIE_CHART_STATISTICS_FAILED = "PIE_CHART_STATISTICS_FAILED";

export const PARTNER_RANKING = "PARTNER_RANKING";
export const PARTNER_RANKING_SUCCESS = "PARTNER_RANKING_SUCCESS";
export const PARTNER_RANKING_FAILED = "PARTNER_RANKING_FAILED";

export const PARTNER_UPDATE_DETAILS = "PARTNER_UPDATE_DETAILS";
export const PARTNER_UPDATE_DETAILS_SUCCESS = "PARTNER_UPDATE_DETAILS_SUCCESS";
export const PARTNER_UPDATE_DETAILS_FAILED = "PARTNER_UPDATE_DETAILS_FAILED";

export const CLEAR_PREVIOUS_REDUCERS = "CLEAR_PREVIOUS_REDUCERS";
